import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Stack,
  Divider,
} from '@mui/material';
import {
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  YouTube,
  LocationOn,
  Phone,
  Email,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const FooterContainer = styled(Box)(({ theme }) => ({
  background: '#0b2b44',
  color: '#dee9f2',
//   padding: theme.spacing(6, 0, 3),
  padding: theme.spacing(6, '5%', 3), // Cambia el padding horizontal a 5%
  width: '100%',
}));

const SocialIcon = styled(IconButton)({
  color: 'white',
  background: 'rgba(255,255,255,0.1)',
  border: '1px solid rgba(255,255,255,0.3)',
  width: 44,
  height: 44,
  '&:hover': {
    color: '#ffb45a',
    transform: 'translateY(-5px)',
    background: 'rgba(255,255,255,0.2)',
    borderColor: '#ffb45a',
  },
});

const FooterLink = styled(Typography)({
  color: '#dee9f2',
  cursor: 'pointer',
  '&:hover': {
    color: '#ffb45a',
  },
});

export default function Footer() {
  return (
    <FooterContainer component="footer" id="contacto">
      {/* Elimina el Container, usa Box directamente */}
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 700, mb: 2 }}>
              Mi Gran Tienda
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <LocationOn sx={{ color: '#ffb45a' }} />
              <Typography>Colombia · Alcance nacional e internacional</Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <SocialIcon><Facebook /></SocialIcon>
              <SocialIcon><Instagram /></SocialIcon>
              <SocialIcon><Twitter /></SocialIcon>
              <SocialIcon><LinkedIn /></SocialIcon>
              <SocialIcon><YouTube /></SocialIcon>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
              Servicios
            </Typography>
            <Typography sx={{ mb: 1 }}>
              Comercialización · Fintech · Inmuebles · Salud · Educación · Construcción · Eventos · Energía
            </Typography>
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography variant="h6" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
              Club & Membresías
            </Typography>
            <Typography>1 UVT persona natural</Typography>
            <Typography>2 UVT persona jurídica</Typography>
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography variant="h6" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
              Acceso rápido
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
              <Phone sx={{ fontSize: 20, color: '#ffb45a' }} />
              <Typography>(601) 555 1234</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Email sx={{ fontSize: 20, color: '#ffb45a' }} />
              <Typography>contacto@migrantienda.com</Typography>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: '#254b66', my: 4 }} />

        <Typography variant="body2" align="center" sx={{ color: '#8ba0b3' }}>
          © 2026 Mi Gran Tienda S.A.S. - Inspirado en objeto social integral.
        </Typography>
      </Box>
    </FooterContainer>
  );
}